import React, { useState, useRef, useEffect } from "react";

import {
    Box,
    // Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    Container,
    Card,
    styled,
    Stack,
    Chip,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableBody,
    TableRow,
    Collapse,
    Tooltip
} from '@mui/material';

import { grey } from "@mui/material/colors";

import * as yup from 'yup';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../context/AppContext";
import { useAuthAccess, authTargetTypes } from "../../../hooks/useAuthAccess";

import { CommonIcons, icons } from "../../common/CommonIcons";
import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from '../../common/CommonRestricted';

import LocationSelector from "../../selector/LocationSelector";
import SearchItems from "../../dialog/SearchItems";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { useInventories, inventoriesTypes } from "../../../hooks/api/useInventories";
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
import { useTranslations } from '../../../hooks/useTranslations';

import { spliceString } from "../../../utils/formatString";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

const getRowsByLocationAndItemIds = ({
    inventoryData,
    locationId,
    itemIds
}) => {

    // console.log('inventoryData', inventoryData)

    const scopeLocationData = inventoryData.filter(item => item.location_id === locationId)

    let results = [];

    if (scopeLocationData.length) {// if have locaation data

        scopeLocationData.map(item => {
            if (itemIds.includes(item.id)) { // matched the item id
                results.push(item)
            }
            return false;
        })
    }

    return results;

}

const RenderSelectedLocations = ({ selectLocationIds }) => {

    if (!selectLocationIds) return <></>
    if (selectLocationIds.length <= 0) return <></>

    return (
        <>
            {
                selectLocationIds.map((item, index) => {
                    return (
                        <Tooltip key={index} title={item?.location_name} placement="bottom" arrow>
                            <Chip
                                label={spliceString({ val: item?.location_name, maxLength: 25 })}
                                variant="outlined"
                                // onDelete={() => {}}
                                sx={{
                                    mr: 1,
                                    mb: 1
                                }}
                            />
                        </Tooltip>
                    )
                })
            }
        </>
    )
}

const RenderSelectedItems = ({ selectItemIds, handleItemOnDelete }) => {

    if (!selectItemIds) return <></>
    if (selectItemIds.length <= 0) return <></>

    return (
        <Box
        >
            {
                selectItemIds.map((item, index) => {
                    return (
                        <Tooltip key={index} title={item?.item_name} placement="bottom" arrow>
                            <Chip
                                label={
                                    `${spliceString({ val: item?.item_name, maxLength: 25 })} (${item?.code})`
                                }
                                variant="outlined"
                                onDelete={() => {
                                    handleItemOnDelete({ item })
                                }}
                                sx={{
                                    mr: 1,
                                    mb: 1
                                }}
                            />
                        </Tooltip>
                    )
                })
            }
        </Box>
    )
}

const RenderFormSearchProduct = ({ formik, t, selectLocationIds, selectItemIds, handleResetLocation, handleItemOnSelect, handleItemOnDelete, handleQuery }) => {

    const { values, errors, touched, handleChange, setFieldValue } = formik

    return (
        <>
            <StyledCard>
                <Grid container spacing={5}>
                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={10} textAlign={"left"}>
                                <CommonSectionHeader
                                    title={t(`selectProducts`)}
                                    subTitle={t(`multipleSelectedItemsForExaminationResults`)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} textAlign={"left"}>
                                <SearchItems
                                    id={"searchItems"}
                                    customDisplay={({ setOpen }) => {

                                        return (
                                            <Button
                                                onClick={() => setOpen(true)}
                                            >
                                                <StyledIcon>
                                                    <CommonIcons name={icons.add} />
                                                </StyledIcon>
                                            </Button>
                                        )

                                    }}
                                    handleOnCancel={() => {

                                    }}
                                    handleOnSearchChange={(event) => {
                                        // setFieldValue('memberDisplay', `${event.target.value}`)
                                    }}
                                    handleOnSelect={handleItemOnSelect}
                                    textProps={{
                                        disabled: true,
                                        value: values?.memberDisplay,
                                        error: Boolean(errors?.memberUserId),
                                        helperText: errors?.memberUserId,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                                <RenderSelectedItems
                                    selectItemIds={selectItemIds}
                                    handleItemOnDelete={handleItemOnDelete}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={10} textAlign={"left"}>
                                <CommonSectionHeader
                                    title={t(`selectLocations`)}
                                    subTitle={t(`scopeTheRangeOfTheSearchLocations`)}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={2} textAlign={"left"}>
                                <Button
                                    onClick={handleResetLocation}
                                >
                                    <StyledIcon>
                                        <CommonIcons name={icons.edit} />
                                    </StyledIcon>
                                </Button>
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                                <RenderSelectedLocations
                                    selectLocationIds={selectLocationIds}
                                />
                            </Grid>
                        </Grid>

                    </Grid>

                </Grid>
            </StyledCard>

            <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                <Grid item md={12} textAlign={"right"}>
                    <Button
                        type="submit"
                        // fullWidth
                        variant="contained"
                        sx={{
                            mt: 3,
                            mb: 2
                        }}
                        // loading={isLoadingCreate}
                        onClick={handleQuery}
                    >
                        {t('startQuery')}
                    </Button>
                </Grid>
            </Grid>
        </>
    )
}

const RenderTable = ({ t, queryData, queryStatsData, selectLocationIds, selectItemIds }) => {

    if (!queryData) return <></>
    if (queryData.length <= 0) return <></>

    return (
        <StyledCard sx={{ mt: 1, p: 0 }}>
            <TableContainer
                // component={Paper}
                sx={{
                    // minHeight: 400,
                    // maxHeight: 400
                }}
            >
                <Table
                    size="small"
                    stickyHeader
                >
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>{t('location')}</TableCell>
                            {/* <TableCell>Description</TableCell> */}
                            <TableCell>{t('state')}</TableCell>
                            {/* <TableCell>UOM</TableCell>
                                <TableCell align="right">Expected Qty</TableCell>
                                <TableCell align="right">Verify</TableCell>
                                <TableCell align="right">Balance</TableCell> */}
                            <TableCell align="right"><></>
                            </TableCell>
                            {/* <TableCell align="right">Unit</TableCell> */}
                            {/* <TableCell align="right">Sum</TableCell> */}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            selectLocationIds?.map((row, index) => (
                                <RenderTableRow
                                    t={t}
                                    key={index}
                                    data={{ ...row, index }}
                                    queryData={queryData}
                                    queryStatsData={queryStatsData}
                                    locationId={row?.id}
                                    selectItemIds={selectItemIds}
                                // rackData={rackData}
                                />
                            ))
                        }

                    </TableBody>
                </Table>
            </TableContainer>
        </StyledCard>
    )
}

const RenderTableRow = ({ t, data, queryData, queryStatsData, locationId, selectItemIds }) => {

    const [open, setOpen] = useState(false)

    return (
        <>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                <TableCell>{(data.index + 1)}</TableCell>
                <TableCell component="th" scope="row">
                    {data?.location_name}
                </TableCell>
                <TableCell>{data?.state_name}</TableCell>
                <TableCell align="right">
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        <StyledIcon>
                            {open ? <CommonIcons name={icons.chevronUp} /> : <CommonIcons name={icons.chevronDown} />}
                        </StyledIcon>

                    </IconButton>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                    <RenderCollapse
                        t={t}
                        queryData={queryData}
                        queryStatsData={queryStatsData}
                        open={open}
                        locationId={locationId}
                        selectItemIds={selectItemIds}
                    />
                </TableCell>
            </TableRow>
        </>
    )
}

const RenderCollapseItemStat = ({
    customCardStyle,
    ComponentIcon,
    title,
    value
}) => {
    return (
        <StyledCard
            sx={{
                py: 1,
                px: 2,
                ...customCardStyle
            }}
        >
            <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                flexDirection={"row"}
            >
                <Box>
                    {
                        ComponentIcon
                    }
                </Box>
                <Box
                    sx={{
                        flex: 1,
                        pl: 1.5
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: 18,
                            fontWeight: 700
                        }}
                    >
                        {value}
                    </Typography>
                    <Typography
                        sx={{
                            mt: -0.5,
                            fontSize: 14,
                        }}
                    >
                        {title}
                    </Typography>
                </Box>
            </Box>
        </StyledCard>
    )
}

const RenderCollapseItem = ({ t, rows, statsRows }) => {

    if (rows.length <= 0) {
        return (
            <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                sx={{
                    py: 4
                }}
            >
                <Typography
                    sx={{
                        color: grey[500]
                    }}
                >
                    {`${t("noDataFound")}`}
                </Typography>
            </Box>
        )
    }


    const _statsRows = statsRows.length > 0 ? statsRows[0] : {}

    let pendingInbound = _statsRows?.pending_inbound_qty
    let transferInTransit = _statsRows?.transfer_in_transit_qty
    let inStock = _statsRows?.total_remain_qty
    let grossStock =
        parseInt(pendingInbound, 10) +
        parseInt(transferInTransit, 10) +
        parseInt(inStock, 10)

    const stats = {
        pendingInbound,
        transferInTransit,
        inStock,
        grossStock
    }

    return (

        <Grid container spacing={1}>
            <Grid item sm={12} xs={12} md={5}>
                {/* {JSON.stringify(statsRows)} */}
                <Grid container spacing={1}>
                    <Grid item sm={6} xs={6} md={6}>
                        <RenderCollapseItemStat
                            customCardStyle={{
                                borderColor: 'primary.main',
                                borderWidth: 2,
                                borderStyle: 'solid'
                            }}
                            ComponentIcon={<CommonIcons name={icons.products} sx={{ width: 50, height: 50 }} />}
                            title={`${t("inStockBalance")}`}
                            value={stats.inStock}
                        />
                    </Grid>
                    <Grid item sm={6} xs={6} md={6}>
                        <RenderCollapseItemStat
                            ComponentIcon={<CommonIcons name={icons.products} sx={{ width: 50, height: 50 }} />}
                            title={`${t("grossBalance")}`}
                            value={stats.grossStock}
                        />
                    </Grid>
                    <Grid item sm={6} xs={6} md={6}>
                        <RenderCollapseItemStat
                            ComponentIcon={<CommonIcons name={icons.products} sx={{ width: 50, height: 50 }} />}
                            title={`${t("transferInTransit")}`}
                            value={stats.transferInTransit}
                        />
                    </Grid>
                    <Grid item sm={6} xs={6} md={6}>
                        <RenderCollapseItemStat
                            ComponentIcon={<CommonIcons name={icons.products} sx={{ width: 50, height: 50 }} />}
                            title={`${t("pendingInbound")}`}
                            value={stats.pendingInbound}
                        />
                    </Grid>
                </Grid>


            </Grid>
            <Grid item sm={12} xs={12} md={7}>
                <StyledCard
                    sx={{
                        p: 0,
                    }}
                >
                    <Table size="small" aria-label="purchases">
                        {/* <TableHead>
                                        <TableRow>
                                            <TableCell colSpan={4} align="center">Verify In Information</TableCell>
                                        </TableRow>
                                    </TableHead> */}
                        <TableHead>
                            <TableRow>
                                <TableCell width={20}>#</TableCell>
                                <TableCell width={150}>{t('item')}</TableCell>
                                <TableCell>{t('code')}</TableCell>
                                <TableCell>{t('batchNo')}</TableCell>
                                <TableCell>{t('expiryDate')}</TableCell>
                                <TableCell>{t('rack')}</TableCell>
                                <TableCell>{t('slot')}</TableCell>
                                <TableCell width={90} align="right">{t('qty')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                rows.length ?
                                    (

                                        rows.map((i, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{(index + 1)}</TableCell>
                                                <TableCell>{i.item_name}</TableCell>
                                                <TableCell>{i.code}</TableCell>
                                                <TableCell>{i.custom_batch_no}</TableCell>
                                                <TableCell>{i.expiry_date}</TableCell>
                                                <TableCell>{i.rack_name}</TableCell>
                                                <TableCell>{i.slot_name}</TableCell>
                                                <TableCell align="right">{i.total_remain_qty}</TableCell>
                                            </TableRow>
                                        ))

                                    )
                                    :
                                    (
                                        <TableRow>
                                            <TableCell colSpan={5} align="center">{t('noDataFound')}</TableCell>
                                        </TableRow>
                                    )
                            }

                        </TableBody>
                    </Table>
                </StyledCard>
            </Grid>
        </Grid>
    )
}

const RenderCollapse = ({ t, open, queryData, queryStatsData, locationId, selectItemIds }) => {

    // getting rows
    const itemIds = selectItemIds.map(item => item.id)
    // console.log('itemIds', itemIds, locationId)

    // get unique item by item id
    const uniqueItemIds = []

    itemIds.forEach(i => {
        if (uniqueItemIds.includes(i) === false) {
            uniqueItemIds.push(i)
        }
    })

    return (
        <Collapse
            in={open}
            timeout="auto"
            unmountOnExit
        // easing={"fadeIn"}
        >

            {
                uniqueItemIds.map((i, index) => {

                    const rows = getRowsByLocationAndItemIds(
                        {
                            inventoryData: queryData,
                            locationId,
                            itemIds: [i]
                        }
                    )

                    const statsRows = getRowsByLocationAndItemIds(
                        {
                            inventoryData: queryStatsData,
                            locationId,
                            itemIds: [i]
                        }
                    )

                    const dividerTitle = statsRows.length > 0 ? statsRows[0]?.item_name : ``

                    return (
                        <Box
                            key={index}
                            sx={{
                                p: 2
                            }}
                        >

                            <Divider textAlign="left" sx={{ py: 1 }}>
                                <Typography
                                    sx={{
                                        color: grey[500],
                                    }}
                                >
                                    {`#${(index + 1)} : ${dividerTitle}`}
                                </Typography>
                            </Divider>

                            <RenderCollapseItem
                                t={t}
                                rows={rows}
                                statsRows={statsRows}
                            />

                        </Box>
                    )
                })
            }

        </Collapse>
    )

}

const RenderForm = ({
    t,
    queryData, queryStatsData,
    formik, selectItemIds, selectLocationIds,
    handleResetLocation, handleItemOnSelect,
    handleItemOnDelete, handleQuery
}) => {

    const { handleSubmit, handleChange, values, errors, touched, setFieldValue, } = formik;

    return (
        <form onSubmit={handleSubmit}>

            <Grid container spacing={1}>

                <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                    <RenderFormSearchProduct
                        t={t}
                        formik={formik}
                        selectItemIds={selectItemIds}
                        selectLocationIds={selectLocationIds}
                        handleResetLocation={handleResetLocation}
                        handleQuery={handleQuery}
                        handleItemOnSelect={handleItemOnSelect}
                        handleItemOnDelete={handleItemOnDelete}
                    />
                    {/* {
                        RenderFormSearchProduct({ values, errors, touched, handleChange, setFieldValue })
                    } */}
                </Grid>

            </Grid>

            <RenderTable
                t={t}
                queryData={queryData}
                queryStatsData={queryStatsData}
                selectLocationIds={selectLocationIds}
                selectItemIds={selectItemIds}
            />

        </form>
    )
}

const RenderMain = ({
    t,
    queryData,
    queryStatsData,
    formik,
    selectItemIds,
    selectLocationIds,
    handleQuery,
    handleLocationOnNext,
    handleResetLocation,
    handleItemOnSelect,
    handleItemOnDelete
}) => {

    // console.log('selectLocationIds', selectLocationIds)

    return (selectLocationIds && selectLocationIds.length > 0) ?
        (
            <RenderForm
                t={t}
                queryData={queryData}
                queryStatsData={queryStatsData}
                formik={formik}
                selectItemIds={selectItemIds}
                selectLocationIds={selectLocationIds}
                handleQuery={handleQuery}
                handleResetLocation={handleResetLocation}
                handleItemOnSelect={handleItemOnSelect}
                handleItemOnDelete={handleItemOnDelete}
            />
        )
        :
        (
            <LocationSelector
                config={{
                    title: t("selectLocations"),
                    description: t("youCanSelectMultipleWarehouseLocationsToProceed")
                }}
                handleOnNext={handleLocationOnNext}
            />
        )
}

export default function ViewInventoryPage({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@operation", "@document", "prompt"] })

    // const { authData, getAvailableLocations } = useAuthAccess();
    // const { getLocationIds, setLocationIds } = useAppContextFeatures();
    const { loading, list, filterOperatorTypes } = useInventories({ inventoriesType: inventoriesTypes.inventory })
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.operation.id, scopeTypes.operation.examineInventory.id)

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { setSystemLoading } = useAppContextFeatures();

    const [selectLocationIds, setSelectLocationIds] = useState()
    const [selectItemIds, setSelectItemIds] = useState([])

    // const availableLocations = getAvailableLocations();

    const [queryData, setQueryData] = useState()
    const [queryDataStats, setQueryDataStats] = useState()

    const onSubmit = async (currentValues) => {

    }

    const formik = useFormik({
        initialValues: {},
        validationSchema: yup.object({}),
        onSubmit
    });

    // useEffect(() => {

    //     const currentLocationIds = getLocationIds();

    //     const selected = [];

    //     if (currentLocationIds && currentLocationIds.length > 0) {

    //         currentLocationIds.map(locationId => {

    //             // console.log('currentLocationIds', currentLocationIds, availableLocations)

    //             // get the location information
    //             const loc = availableLocations.filter(i => i.id === locationId)

    //             if (loc.length) {
    //                 selected.push(loc[0])
    //             }

    //             return false;

    //         })
    //     }

    //     setSelectLocationIds(selected)

    // }, [getLocationIds])

    const fetchData = async ({ locationIds, itemIds }) => {

        // [{ "field": "location_id", "operator": "where_in", "value": "[17,18]" }]

        try {

            let props = {
                limit: 100000,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: -1,
                },
                filterValue: [
                    {
                        name: "location_id",
                        operator: filterOperatorTypes.anyOf,
                        value: JSON.stringify(locationIds)
                    },
                    {
                        name: "id",
                        operator: filterOperatorTypes.anyOf,
                        value: JSON.stringify(itemIds)
                    }
                ]
            }

            props.dataTypes = ["group_slot_batch"]

            let response = await list(props);

            setQueryData(response?.data?.inventories ? response?.data?.inventories : [])

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }


    }

    const fetchData2 = async ({ itemIds, locationIds }) => {

        let props = {
            limit: 100000,
            skip: 0,
            sortInfo: {
                id: "id",
                dir: -1,
            },
            filterValue: [
                {
                    name: "location_id",
                    operator: filterOperatorTypes.anyOf,
                    value: JSON.stringify(locationIds)
                },
                {
                    name: "id",
                    operator: filterOperatorTypes.anyOf,
                    value: JSON.stringify(itemIds)
                }
            ]
        }

        props.dataTypes = ["group_location", "pending_inbound", "transfer_in_transit"]

        let response = await list(props);

        setQueryDataStats(response?.data?.inventories ? response?.data?.inventories : [])


    }

    const handleQuery = async () => {

        setSystemLoading(true);

        try {

            // check the selection item ids
            if (selectItemIds.length <= 0) {
                throw Error(`${t("pleaseSelectAtLeast1Item")}`)
            }

            const itemIds = selectItemIds.map(i => i.id)
            const locationIds = selectLocationIds.map(i => i.id)

            console.log('locationIds', locationIds)

            await fetchData({ locationIds, itemIds })
            await fetchData2({ locationIds, itemIds })


            setSystemLoading(false)

        } catch (error) {
            setSystemLoading(false)
            promptMessage(false, `${error.message}`)
        }


    }

    const handleItemDeselect = ({ id }) => {
        setQueryData([])
        setQueryDataStats([])
        setSelectItemIds(
            selectItemIds.filter(item => item.id !== id)
        )
    }


    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.viewInventory })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("examineInventory")}
                breadcrumbs={[
                    {
                        displayText: t("examineInventory"),
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageView.id }) ?
                    (
                        <RenderMain
                            t={t}
                            queryData={queryData}
                            queryStatsData={queryDataStats}
                            formik={formik}
                            selectItemIds={selectItemIds}
                            selectLocationIds={selectLocationIds}
                            handleQuery={handleQuery}
                            handleLocationOnNext={({ selected }) => {
                                // console.log('selected', selected)
                                setQueryData([])
                                setQueryDataStats([])
                                setSelectLocationIds(selected)
                            }}
                            handleResetLocation={() => setSelectLocationIds([])}
                            handleItemOnSelect={({ id, item }) => {
                                setSelectItemIds([...selectItemIds, item])
                                // setFieldValue('memberUserId', item?.user_id)
                                // setFieldValue('memberDisplay', `${item?.firstname} ${item?.lastname}`)
                            }}
                            handleItemOnDelete={({ item }) => handleItemDeselect({ id: item?.id })}
                        />
                    )
                    :
                    (
                        <CommonRestricted />
                    )
            }

        </Box>
    )
}